<template>
  <c-page class="page-index">
    <c-page-section class="title-section flex-center">
      <img :src="picture" />
    </c-page-section>
  </c-page>
</template>

<script setup lang="ts">
import { computed, useCurrentAppInstance } from '@zto/zpage'

const app = useCurrentAppInstance()

const imageAssets = app.useAssets('images', {})

const picture = computed(() => {
  return imageAssets.welcome || imageAssets.logo
})
</script>

<style lang="scss" scoped>
.page-index {
  padding: 50px;
  text-align: center;
}

.title-section {
  height: 300px;

  .title {
    font-size: 30px;
    opacity: 0.6;
  }

  img {
    height: 100px;
    opacity: 0.8;
  }
}
</style>
